import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface Category {
  id: number;
  name: string;
  slug: string;
  description: string;
}

export interface Subcategory {
  id: number;
  name: string;
  slug: string;
  description: string;
}

export interface CategoryWithSubcategories extends Category {
  subcategories: Subcategory[];
}

@Injectable({
  providedIn: 'root',
})
export class CategoriesService {
  private apiUrl = environment.apiUrl || 'http://localhost:3000/api/v1';

  constructor(private http: HttpClient) {}

  getCategories(): Observable<Category[]> {
    return this.http.get<Category[]>(`${this.apiUrl}/categories`);
  }

  getSubcategories(categorySlug: string): Observable<Subcategory[]> {
    return this.http.get<Subcategory[]>(
      `${this.apiUrl}/categories/${categorySlug}/subcategories`
    );
  }

  getCategoryWithSubcategories(
    categorySlug: string
  ): Observable<CategoryWithSubcategories> {
    return this.http.get<CategoryWithSubcategories>(
      `${this.apiUrl}/categories/${categorySlug}`
    );
  }
}
